// src/utils/testFiles.js
// Test files (Henry 10/06/2026): "123 TEST ST SMOKE ... we can do a ton of tests with it, and it doesn't
// count towards any of our numbers. Nobody has assigned tasks from this. It's just for me to do trial and
// error on."
//
// A deal is a test file when its address has the word TEST on its own (the junk rule the Status Sheet has
// always used: "123 TEST ST SMOKE" and "123 test street" match, "Testman Ave" and "Smokey Hollow Rd" never
// do), or when it carries isTestFile: true. A test file:
//   - never counts toward any number (reports, Team Performance, goals, conversion, Impact, the dashboard,
//     the accountant's screens, caps and leaderboards),
//   - never hands work to anyone (no automatic task owners, no My Checklist rows, no Listing Prep chasing),
//   - never alerts anyone on its own (approvals, milestones, follow-ups, the 7 AM email).
// It still shows on the Deals Board, the Transactions page and its own deal page, so it can be used for
// trial and error. Server twin: functions-api/testFiles.js (same rule, change both together).
import { looksLikeJunk } from "./junkFilter";
import { isSuperAdminOwner } from "./owner";

// Deals carry propertyaddress, leads, plans and requests propertyAddress, listing appointments address.
export const isTestFile = (deal) =>
  !!deal &&
  (deal.isTestFile === true ||
    looksLikeJunk(deal.propertyaddress || deal.propertyAddress || deal.address || ""));

// The list without test files. Anything that is not a list (still loading) is handed back unchanged.
export const withoutTestFiles = (deals) => (Array.isArray(deals) ? deals.filter((d) => !isTestFile(d)) : deals);

// A work queue (Pending Approval, File Requests, the accountant queue, Listing Prep, Inspection Requests,
// Follow-Ups): the owner still sees a test file there so he can try each step on it; nobody else ever does.
// While he is using View As he sees what that person would.
export const canSeeTestFiles = (user) => isSuperAdminOwner(user);
// The same, from that yes/no. Screens remember their rows on it rather than on the whole person, so a
// redraw that changes nothing about who is looking hands back the very same rows.
export const keepTestFilesIf = (show, list) => (show ? list : withoutTestFiles(list));
export const visibleTestFiles = (user, list) => keepTestFilesIf(canSeeTestFiles(user), list);
